<angular-template>
    <vrm-graph-custom-widget
        widget-id="widgetId"
        installation="installation"
        data="data"
        series="series"
        data-title="title"
        type="TYPE"
        tooltip="tooltip"
        loading="loading"
        zoomstate="zoomstate"
        icon-class="'custom-widget'"
        range="range"
        is-mobile="isMobile"
        is-advanced-view="isAdvancedView"
        has-touch-enabled="hasTouchEnabled"
        y-axis-properties="yAxisProperties"
        size="size"
        item-state="itemState"
        persistent-mode="persistentMode"
        can-be-updated="canBeUpdated"
    />
</angular-template>
<style scoped lang="scss"></style>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { WIDGET_TYPE } from '@/vue/components/shared/widget/codeToType';

@Component({})
export default class GraphCustomWidget extends Vue {
    @Prop()
    widgetId;
    @Prop({ type: Object, default: null })
    installation;
    @Prop({ type: Object, default: null })
    data;
    @Prop({ type: Array, default: null })
    series;
    @Prop({ type: String, default: '' })
    title;
    @Prop({ type: String, default: '' })
    tooltip;
    @Prop({ type: Boolean, default: false })
    loading;
    @Prop({ type: Object, default: null })
    zoomstate;
    @Prop({ type: Object, default: null })
    range;
    @Prop({ type: Boolean, default: false })
    isMobile;
    @Prop({ type: Boolean, default: false })
    isAdvancedView;
    @Prop({ type: Boolean, default: false })
    hasTouchEnabled;
    @Prop({ type: Object, default: null })
    yAxisProperties;
    @Prop({ type: String, default: '0x0' })
    size;
    @Prop({ type: Object, default: null })
    itemState;
    @Prop({ type: Boolean, default: false })
    persistentMode;
    @Prop({ type: Boolean, default: false })
    canBeUpdated;

    TYPE = WIDGET_TYPE.CUSTOM;
}
</script>
